const PUBLIC_PAGES = ['/', '/innsyn'];

export function isOnPublicPage() {
  return PUBLIC_PAGES.includes(window.location.pathname);
}
